import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Filename = styled(Typography)`
  cursor: pointer;
  display: inline-block;
`;
